import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthenticationSandbox } from '@app/authentication/sandboxes/authentication.sandbox';
import { StatusBadgeStatus } from '@ui-v2/atoms/status-badge/status-badge.constants';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
    selector: 'app-service-status-icon',
    standalone: true,
    imports: [InlineSVGModule],
    template: `@switch (status) {
        @case (StatusBadgeStatus.Complete) {
            <div class="text-icon-success" inlineSVG="https://assets.smooved.be/icons/v2/20/check-filled.svg"></div>
        }
        @case (StatusBadgeStatus.ToComplete) {
            <div class="text-icon-error" inlineSVG="https://assets.smooved.be/icons/v2/20/circle-alert-default.svg"></div>
        }
        @case (StatusBadgeStatus.Unknown) {
            @if (isRealEstateAgent()) {
                <div class="text-icon-error" inlineSVG="https://assets.smooved.be/icons/v2/20/circle-alert-default.svg"></div>
            } @else {
                <div class="text-icon-tertiary" inlineSVG="https://assets.smooved.be/icons/v2/20/circle-dashed.svg"></div>
            }
        }
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceStatusIconComponent {
    @Input() public status: StatusBadgeStatus;

    private readonly authenticationSandbox = inject(AuthenticationSandbox);

    public isRealEstateAgent = toSignal(this.authenticationSandbox.isRealEstateAgent$);

    protected readonly StatusBadgeStatus = StatusBadgeStatus;
}
